<script setup lang="ts">
interface Props {
  value?: string
  size?: 'xs' | 'sm' | 'md'
}

const props = withDefaults(defineProps<Props>(), {
  size: 'sm'
})

const sizeClasses = {
  xs: 'text-[10px] px-1 py-0.5',
  sm: 'text-xs px-1.5 py-0.5',
  md: 'text-sm px-2 py-1'
}
</script>

<template>
  <kbd
    class="inline-flex items-center justify-center rounded border border-gray-200 bg-gray-100 font-mono font-medium text-gray-600"
    :class="sizeClasses[size]"
  >
    <slot>{{ value }}</slot>
  </kbd>
</template>
